import {GeocoderItem} from '@/interface';

export const searchKakaoLocalAddress = (address: string, size?: number) =>
  new Promise<{
    result: GeocoderItem[];
    status: kakao.maps.services.Status;
    pagination: kakao.maps.services.Pagination;
  }>((resolve, reject) => {
    const geocoder = new kakao.maps.services.Geocoder();

    if (!geocoder) {
      return reject('geocoder 로드 실패');
    }

    geocoder.addressSearch(
      address,
      (
        result: GeocoderItem[],
        status: kakao.maps.services.Status,
        pagination: kakao.maps.services.Pagination
      ) => {
        return resolve({
          result,
          status,
          pagination,
        });
      },
      {
        size,
        analyze_type: kakao.maps.services.AnalyzeType.SIMILAR,
      }
    );
  });

export const searchNaverLocalAddress = (query: string) =>
  new Promise<naver.maps.Service.GeocodeResponse['v2']>((resolve, reject) => {
    if (!naver.maps.Service.geocode) {
      return reject('geocoder 로드 실패');
    }

    naver.maps.Service.geocode(
      {query},
      (
        status: naver.maps.Service.Status,
        response: naver.maps.Service.GeocodeResponse
      ) => {
        if (status === naver.maps.Service.Status.ERROR) {
          return reject(
            `[주소 검색 오류]: ${response?.v2?.errorMessage} (code: ${status})`
          );
        }

        return resolve({
          ...response.v2,
        });
      }
    );
  });

export const convertNaverAddressToKakaoAddress = (
  origin: naver.maps.Service.AddressItemV2[]
) => {
  return origin.map((i) => {
    const type = i.roadAddress?.length
      ? i.roadAddress === i.jibunAddress
        ? 'REGION'
        : 'ROAD_ADDR'
      : 'REGION_ADDR';
    const xy = {
      x: i.x,
      y: i.y,
    };

    const obj: GeocoderItem = {
      address_type: type,
      address_name: i.roadAddress || i.jibunAddress,
      ...xy,
    };

    if (type === 'REGION_ADDR' && i.roadAddress) {
      obj.road_address = {
        address_name: i.roadAddress,
        ...xy,
      };
    } else if (type === 'ROAD_ADDR' && i.jibunAddress) {
      obj.address = {
        address_name: i.jibunAddress,
        ...xy,
      };
    }

    return obj;
  });
};

export const useThirdPartyAddressSearch = () => {
  const run = async (keyword: string, limit?: number) => {
    try {
      const {result} = await searchKakaoLocalAddress(keyword, limit);

      return result;
    } catch (kakaoError) {
      try {
        const result = await searchNaverLocalAddress(keyword);

        if (result?.addresses) {
          return convertNaverAddressToKakaoAddress(result.addresses);
        } else {
          throw Error('[네이버 주소 검색] 응답 객체 없음');
        }
      } catch (naverError) {
        console.error(naverError);
      }
    }
  };

  return run;
};
